import React from 'react'
import { Row, Col } from 'react-bootstrap';
import './ChallengeVideo.css';
import VideoModal from "./VideoModal";
//import videoThumb1 from '../images/video-thumb-1.jpg';

function ChallengeVideo() {
    const [modalShow, setModalShow] = React.useState(false);
    const [videoid, setVideoId] = React.useState('');
    function openModal(e, videoName) {
        e.preventDefault();
        setModalShow(true);
        setVideoId(videoName)
    }
    const challengeList = [
        {
            "class": "challenge-thumb-helicopter",
            "videoId": "Mxb7rknf5kg",
            "title": "Helicopter"
        },
        {
            "class": "challenge-thumb-yorker",
            "videoId": "gIyJxtKoOW4",
            "title": "Yorker"
        },
        {
            "class": "challenge-thumb-stumping",
            "videoId": "O0hNmbLOAmA",
            "title": "Stumping"
        }
    ]

    return (
        <div>
            <Row className="challenge-video text-center">
                {challengeList.map((challenge, i) => {
                    let vUrl = 'https://img.youtube.com/vi/' + challenge.videoId + '/sddefault.jpg'
                    return (<Col md={4} key={i}>
                        <div className={'challenge-thumb-wrapper ' + challenge.class}>
                            <h3>{challenge.title}<br />
                                <span className="text-orange">Challenge</span></h3>
                            <a href="#" className="video-thumb-link" onClick={(e) => openModal(e, `${challenge.videoId}`)}><div className="video-thumb">
                                <img src={vUrl} className="img-fluid" alt="" />
                            </div></a>
                        </div>
                    </Col>)
                })}
            </Row>
            <VideoModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                videoid={videoid}
            />
        </div>
    );
}

export default ChallengeVideo;